export enum TrackingEvent {
  ContextPanelHover = `Context panel hover`,
}
